import { jsx as _jsx } from "react/jsx-runtime";
import React from "react";
import { Select } from "antd";
import { ScheduleFrequencyEnum } from "../routes/vehicleHires/api/Representation";
const TemplateScheduleFrequencySelect = ({ value, onChange, disabled = false }) => {
    return (_jsx(Select, { disabled: disabled, allowClear: false, showSearch: false, value: value, onChange: onChange, options: [
            { value: ScheduleFrequencyEnum.DAILY, label: 'Days' },
            { value: ScheduleFrequencyEnum.DAILY_EX_WEEKEND, label: 'Day Excluding Weekends' },
            { value: ScheduleFrequencyEnum.WEEKLY, label: 'Weeks' },
            { value: ScheduleFrequencyEnum.MONTHLY, label: 'Months' },
            { value: ScheduleFrequencyEnum.YEARLY, label: 'Years' }
        ] }));
};
export default TemplateScheduleFrequencySelect;
